<template>
  <VDialog
    v-if="isCancelingBookingDialogOpen"
    :value="isCancelingBookingDialogOpen"
    width="425"
    persistent
    outlined
    data-test="cancelling-booking-dialog"
  >
    <VCard>
      <VCardTitle>
        <VRow class="pl-4 pt-4 pb-6">
          <h6
            color="textPrimary"
            class="heading-6"
            data-test="cancelling-booking-title"
          >
            {{ $t('checkout.cancelingBooking') }}
          </h6>
        </VRow>
      </VCardTitle>
      <VCardText class="pb-6">
        <span class="body-1" data-test="cancelling-booking-warning">
          {{ $t('checkout.cancelingWarning') }}
        </span>
      </VCardText>
      <VCardActions class="px-4 pt-0 pb-4">
        <div class="px-1 w-50">
          <VBtn
            class="w-100"
            outlined
            data-test="keep-booking-button"
            @click.stop="$emit('closeDialog')"
          >
            <span class="button">
              {{ $t('checkout.noKeepIt') }}
            </span>
          </VBtn>
        </div>
        <VSpacer />
        <div class="px-1 w-50">
          <VBtn
            class="w-100"
            color="error header__link"
            dark
            data-test="proceed-to-booking-button"
            @click.stop="$emit('closeDialog')"
            :to="{ name: 'Booking' }"
          >
            <span class="button">
              {{ $t('checkout.yesProceed') }}
            </span>
          </VBtn>
        </div>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
<script lang="ts">
export default {
  name: 'SCancellingBookingDialog',
};
</script>

<script setup lang="ts">
defineProps({
  isCancelingBookingDialogOpen: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="scss" scoped>
@import "@slg/web-customer-shared/src/style/headerLinks.scss";
</style>
